<template>
  <v-snackbar
    id="app_snackbar"
    :timeout="snackBarTime"
    :value="showSnackBar"
    absolute
    top
    :color="snackBarType"
    centered
    outlined
    class="custom-snackbar"
  >
    <div
      v-if="snackBarMsg"
      class="d-flex align-center cursor_pointer snack-content"
      @click="showMessageBar = false"
    >
      <div>
        <!-- Image instead of using icon -->
        <img
          v-if="imageName"
          alt="snackbar-image"
          width="30"
          height="30"
          :src="getImageUrl"
          class="mr-2"
        />

        <!-- only for success the icon name gets change -->
        <v-icon v-else :color="snackBarType" size="30" class="mr-2">
          {{ snackbarIcon }}
        </v-icon>

        {{ snackBarMsg }}
      </div>
      <v-icon
        :color="snackBarType"
        size="30"
        class="mr-2"
        @click="showMessageBar = false"
      >
        close
      </v-icon>
    </div>
    <slot name="custom-alert"></slot>
  </v-snackbar>
</template>

<script>
export default {
  name: "AppSnackBar",
  props: {
    showSnackBar: {
      type: Boolean,
      required: true,
    },
    snackBarMsg: {
      type: String,
      default: "",
    },

    imageName: {
      type: String,
      default: "",
    },
    // warning/error/success/info
    snackBarType: {
      type: String,
      default: "",
    },
    snackBarTime: {
      type: [String, Number],
      default: 5000,
    },
  },

  data() {
    return {
      showMessageBar: false,
    };
  },
  computed: {
    //to know whether browser support webp or not
    isBrowserSupportWebp() {
      return this.$store.state.isWebpSupport;
    },
    getImageUrl() {
      if (this.isBrowserSupportWebp)
        return require("@/assets/images/" + this.imageName + ".webp");
      else return require("@/assets/images/" + this.imageName + ".png");
    },
    snackbarIcon() {
      switch (this.snackBarType) {
        case "success":
          return "check_circle";
        case "warning":
          return "error";
        case "error":
          return "cancel";
        default:
          return "info";
      }
    },
  },

  watch: {
    showMessageBar(val) {
      !val ? this.$emit("close-snack-bar") : "";
    },
  },
  mounted() {
    this.showMessageBar = this.showSnackBar;
    // timeout -1 keeps the snackbar open until closed manually
    if (this.snackBarTime > 0) {
      setTimeout(() => {
        this.showMessageBar = false;
      }, 5000);
    }
  },
};
</script>

<style lang="css">
.custom-snackbar {
  max-width: 100% !important;
  min-height: 48px !important;
  width: 100% !important;
  z-index: 1000 !important;
  position: fixed !important;
  padding: 0px !important;
}

.snack-content {
  font-size: 1.2em;
  font-weight: 500;
  justify-content: space-between;
}
#app_snackbar > .v-snack__wrapper {
  width: 100% !important;
  min-height: 55px !important;
  border-radius: 0px;
  max-width: 100% !important;
  position: fixed !important;
  margin: 0 !important;
  padding: 0px !important;
  left: 0px !important;
  right: 0px !important;
  background-color: white !important;
  box-shadow: 0px 1px 15px rgba(15, 84, 136, 0.14) !important;
  border: 2px solid !important;
}
</style>
